module.exports = __webpack_public_path__ + "static/media/wpp_chat_window.8607fe7a.svg";